export default __webpack_public_path__ + "static/media/010-mailbox.dc41ee4b.svg";